import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { Bau365DataAccessFairDataModule } from '@planone/bau365/data-access-fair-data';
import { Bau365FeatureBreadcrumbModule } from '@planone/bau365/feature-breadcrumb';
import { Bau365FeatureUserProfileSharedModule } from '@planone/bau365/feature-user-profile';
import { Bau365FeatureWatchlistSharedModule } from '@planone/bau365/feature-watchlist';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SharedUtilPipelinesModule } from '@planone/shared/util-pipelines';
import { SharedUiSwiperModule } from '@planone/shared-feature-swiper';

import { BrandCardComponent } from './brand-card/brand-card.component';
import { BrandCardListComponent } from './brand-card-list/brand-card-list.component';
import { ExhibitorCardComponent } from './exhibitor-card/exhibitor-card.component';
import { ExhibitorCardListComponent } from './exhibitor-card-list/exhibitor-card-list.component';
import { SectionExhibitorBrandsComponent } from './page-exhibitor-details/section-brands/section-brands.component';
import { SectionExhibitorContactComponent } from './page-exhibitor-details/section-contact/section-contact.component';
import { SectionExhibitorContactPersonsComponent } from './page-exhibitor-details/section-contact-persons/section-contact-persons.component';
import { SectionExhibitorDownloadsComponent } from './page-exhibitor-details/section-downloads/section-downloads.component';
import { SectionExhibitorExhibitorReferencesComponent } from './page-exhibitor-details/section-exhibitor-references/section-exhibitor-references.component';
import { SectionExhibitorHeaderComponent } from './page-exhibitor-details/section-header/section-header.component';
import { SectionExhibitorInfoComponent } from './page-exhibitor-details/section-info/section-info.component';
import { SectionExhibitorLinksComponent } from './page-exhibitor-details/section-links/section-links.component';
import { SectionExhibitorMediaComponent } from './page-exhibitor-details/section-media/section-media.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUiElementsModule,
    Bau365DataAccessFairDataModule,
    Bau365FeatureBreadcrumbModule,
    Bau365FeatureWatchlistSharedModule,
    Bau365FeatureUserProfileSharedModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    SharedUtilPipelinesModule,
    RouterLink,
    SharedUiSwiperModule,
  ],
  declarations: [
    ExhibitorCardComponent,
    ExhibitorCardListComponent,
    BrandCardComponent,
    BrandCardListComponent,
    SectionExhibitorBrandsComponent,
    SectionExhibitorContactComponent,
    SectionExhibitorContactPersonsComponent,
    SectionExhibitorDownloadsComponent,
    SectionExhibitorExhibitorReferencesComponent,
    SectionExhibitorHeaderComponent,
    SectionExhibitorInfoComponent,
    SectionExhibitorLinksComponent,
    SectionExhibitorMediaComponent,
  ],
  exports: [
    ExhibitorCardComponent,
    ExhibitorCardListComponent,
    BrandCardComponent,
    BrandCardListComponent,
    SectionExhibitorBrandsComponent,
    SectionExhibitorContactComponent,
    SectionExhibitorContactPersonsComponent,
    SectionExhibitorDownloadsComponent,
    SectionExhibitorExhibitorReferencesComponent,
    SectionExhibitorHeaderComponent,
    SectionExhibitorInfoComponent,
    SectionExhibitorLinksComponent,
    SectionExhibitorMediaComponent,
  ],
})
export class Bau365FeatureExhibitorsSharedModule {}
